
import { 
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { ArrowUp, ArrowDown } from "lucide-react";
import { CRMData, SortConfig } from "./types";
import { formatDate } from "../../utils/formatters";

interface CRMTableProps {
  data: CRMData[];
  sortConfig: SortConfig | null;
  onSort: (key: keyof CRMData) => void;
}

export const CRMTable = ({ data, sortConfig, onSort }: CRMTableProps) => {
  const getSortIcon = (columnKey: keyof CRMData) => {
    if (sortConfig && sortConfig.key === columnKey) {
      return sortConfig.direction === 'asc' ? <ArrowUp size={14} /> : <ArrowDown size={14} />;
    }
    return null;
  };

  return (
    <div className="overflow-auto max-h-[600px]">
      <Table>
        <TableCaption>Base de données CRM complète</TableCaption>
        <TableHeader className="sticky top-0 z-10 bg-primary/95 shadow-md">
          <TableRow className="hover:bg-primary">
            <TableHead onClick={() => onSort('email')} className="cursor-pointer text-primary-foreground hover:bg-primary/90 transition-colors">
              Email {getSortIcon('email')}
            </TableHead>
            <TableHead onClick={() => onSort('nom')} className="cursor-pointer text-primary-foreground hover:bg-primary/90 transition-colors">
              Nom {getSortIcon('nom')}
            </TableHead>
            <TableHead onClick={() => onSort('prenom')} className="cursor-pointer text-primary-foreground hover:bg-primary/90 transition-colors">
              Prénom {getSortIcon('prenom')}
            </TableHead>
            <TableHead onClick={() => onSort('type_adhesion')} className="cursor-pointer text-primary-foreground hover:bg-primary/90 transition-colors">
              Type {getSortIcon('type_adhesion')}
            </TableHead>
            <TableHead onClick={() => onSort('date_adhesion')} className="cursor-pointer text-primary-foreground hover:bg-primary/90 transition-colors">
              Date adhésion {getSortIcon('date_adhesion')}
            </TableHead>
            <TableHead onClick={() => onSort('date_signature')} className="cursor-pointer text-primary-foreground hover:bg-primary/90 transition-colors">
              Date signature {getSortIcon('date_signature')}
            </TableHead>
            <TableHead onClick={() => onSort('date_abonnement_newsletter')} className="cursor-pointer text-primary-foreground hover:bg-primary/90 transition-colors">
              Date newsletter {getSortIcon('date_abonnement_newsletter')}
            </TableHead>
            <TableHead onClick={() => onSort('montant_adhesion')} className="cursor-pointer text-primary-foreground hover:bg-primary/90 transition-colors">
              Montant adhésion {getSortIcon('montant_adhesion')}
            </TableHead>
            <TableHead onClick={() => onSort('montant_don')} className="cursor-pointer text-primary-foreground hover:bg-primary/90 transition-colors">
              Don {getSortIcon('montant_don')}
            </TableHead>
            <TableHead onClick={() => onSort('ville')} className="cursor-pointer text-primary-foreground hover:bg-primary/90 transition-colors">
              Ville {getSortIcon('ville')}
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {data.map((item) => (
            <TableRow key={item.id} className="bg-background/95 border-b border-border/30">
              <TableCell>{item.email}</TableCell>
              <TableCell>{item.nom}</TableCell>
              <TableCell>{item.prenom}</TableCell>
              <TableCell>
                {[
                  item.type_adhesion ? "Adhérent" : "",
                  item.signataire ? "Signataire" : "",
                  item.abonne_newsletter ? "Newsletter" : "",
                  item.donateur ? "Donateur" : ""
                ].filter(Boolean).join(", ") || "—"}
              </TableCell>
              <TableCell>{formatDate(item.date_adhesion)}</TableCell>
              <TableCell>{formatDate(item.date_signature)}</TableCell>
              <TableCell>{formatDate(item.date_abonnement_newsletter)}</TableCell>
              <TableCell>{item.montant_adhesion ? `${item.montant_adhesion}€` : "—"}</TableCell>
              <TableCell>{item.montant_don ? `${item.montant_don}€` : "—"}</TableCell>
              <TableCell>{item.ville || "—"}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
